import { EDirection } from 'src/styles/theme/utils/enums';
import { IHotkeyTooltipData } from './HotkeyTooltip.type';

export const hotkeyTexts: Record<string, IHotkeyTooltipData> = {
	previousPage: {
		hotkeys: ['a'],
		text: 'previous page',
		direction: EDirection.left
	},
	nextPage: {
		hotkeys: ['d'],
		text: 'next page',
		direction: EDirection.right
	},
	previousCampaign: {
		hotkeys: ['q'],
		text: 'previous campaign'
	},
	nextCampaign: {
		hotkeys: ['e'],
		text: 'next campaign'
	},
	showQuests: {
		hotkeys: ['r'],
		text: 'show quests'
	},
	showCampaigns: {
		hotkeys: ['f'],
		text: 'show campaigns'
	},
	startQuest: {
		hotkeys: ['f'],
		text: 'start quest'
	},
	goToCampaign: {
		hotkeys: ['r'],
		text: 'go to campaign'
	},
	hints: {
		hotkeys: ['h'],
		text: 'hints'
	},
	verify: {
		hotkeys: ['f'],
		text: 'verify'
	},
	closePanel: {
		hotkeys: ['esc'],
		text: 'close panel'
	},
	questDotNavigation: {
		textFn: (index: number, length: number) => {
			if (index === 0) return 'prelude';
			if (index === length - 1) return 'summary';
			if (index === length - 2) return 'postlude';
			return `part ${index}`;
		}
	}
};
